import { Skeleton } from '@/components/ui/skeleton'

/**
 * Skeleton for the loading state of a record
 */
export function RecordSkeleton() {
  const numberOfSkeletons = 3

  return (
    <div className="flex flex-col gap-4 ps-6 pt-5">
      {Array.from({ length: numberOfSkeletons }, (_, index) => (
        <div key={index} className="flex flex-col gap-2">
          <Skeleton className="h-[20px] w-[100px] rounded" />
          <Skeleton className="h-[34px] w-[500px] rounded" />
        </div>
      ))}
    </div>
  )
}
